// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('ArticleNumberMappingListVO')
export class ArticleNumberMappingListVO {
  @JsonProperty('name', 'String')
  public name: string = undefined;

  @JsonProperty('isDefault', 'Boolean')
  public isDefault: boolean = undefined;

  @JsonProperty('isActive', 'Boolean')
  public isActive: boolean = undefined;

  @JsonProperty('entries', '[ArticleNumberMappingVO]')
  public entries: ArticleNumberMappingVO[] = [];
}

@JsonObject('ArticleNumberMappingVO')
export class ArticleNumberMappingVO {
  @JsonProperty('articleNumber', 'String')
  public articleNumber: string = undefined;

  @JsonProperty('customArticleNumber', 'String')
  public customArticleNumber: string = undefined;

  public equals(articleNumberMapping: ArticleNumberMappingVO): boolean {
    return this.articleNumber === articleNumberMapping.articleNumber
      && this.customArticleNumber === articleNumberMapping.customArticleNumber;
  }
}

@JsonObject('ArticleNumberMappingUserDTO')
export class ArticleNumberMappingUserDTO {
  @JsonProperty('userId', 'Number')
  public userId: number = undefined;

  @JsonProperty('articleNumberMappingLists', '[ArticleNumberMappingListVO]')
  public articleNumberMappingLists: ArticleNumberMappingListVO[] = undefined;
}
